import { Reducer } from 'redux';
import { reducer as simpleFormReducer, INITIAL_SIMPLEFORM_STATE } from 'app/infrastructure/simple-form/reducers';
import { STATE } from 'app/constants';
import { ACTION, RequestReports, ReceiveReports, ReceiveFolderFavourite, ClearFolderData, 
  ReceiveSearchRequiredUsers, RequestBookmarkedReports, ReceiveBookmarkedReports, ChangeViewMode, ChangeViewModeCompanyReport, 
  ChangeViewModeDashboard} from './action-types';
import { RequestExecuteReport } from './action-types';
import { ClearAll, RequestNewFolder, ClearNewFolder } from 'app/area/saved-reports/action-types';
import { SavedReportState, ViewMode } from './types-store';
import { codeItemToStoreValue } from 'app/infrastructure/data/codes';
import { clientCache } from 'app/infrastructure/universal';
import { viewModeCacheKeySavedCompanyReports, viewModeCacheKeySavedDashboards, viewModeCacheKeySavedReports } from 'app/area/saved-reports/constants';

const INITIAL_STATE: SavedReportState = {
  fetching: false,
  fetchingCreateFolder: false,
  texts: {},
  validation: {},
  error: false,
  reports: {fetching: false, items: []},
  searchRequiredUsers: undefined,
  bookmarkedReports: {fetching: false, items: []},
  viewMode: clientCache.getItem(viewModeCacheKeySavedReports) || ViewMode.allReports,
  viewModeCompanyReport: clientCache.getItem(viewModeCacheKeySavedCompanyReports) || ViewMode.allReports,
  viewModeDashboard: clientCache.getItem(viewModeCacheKeySavedDashboards) || ViewMode.allReports,
  ...INITIAL_SIMPLEFORM_STATE
};

export const reducers: { [indexer: string]: Reducer<SavedReportState> } = {
  [ACTION.REQUEST_EXECUTE_REPORT]: (state: SavedReportState, action: RequestExecuteReport): SavedReportState => {
    return {
      ...state,
      fetching: true
    };
  },
  [ACTION.REQUEST_FAILED]: (state: SavedReportState, action: RequestExecuteReport): SavedReportState => {
    return {
      ...state,
      fetching: false,
      error: true
    };
  },

  [ACTION.REQUEST_NEW_FOLDER]: (state: SavedReportState, action: RequestNewFolder): SavedReportState => {
    return {
      ...state,
      fetchingCreateFolder: true
    };
  },

  [ACTION.CLEAR_NEW_FOLDER]: (state: SavedReportState, action: ClearNewFolder): SavedReportState => {
    return {
      ...state,
      fetchingCreateFolder: false
    };
  },

  [ACTION.CLEAR_ALL]: (state: SavedReportState, action: ClearAll): SavedReportState => {
    return {
      ...state,
      ...INITIAL_STATE,
      viewMode: state.viewMode,
      viewModeCompanyReport: state.viewModeCompanyReport,
      viewModeDashboard: state.viewModeDashboard
    };
  },

  [ACTION.CLEAR_FOLDER_DATA]: (state: SavedReportState, action: ClearFolderData): SavedReportState => {
    return {
      ...state,
      folderDefinition: null,
      fetchingFolder: false
    };
  },

  [ACTION.REQUEST_REPORTS]: (state: SavedReportState, action: RequestReports): SavedReportState => {

    return {
      ...state,
      folderDefinition: null,
      reports: {
        fetching: true,
        items: []
      }
    };
  },

  [ACTION.RECEIVE_REPORT]: (state: SavedReportState, action: ReceiveReports): SavedReportState => {

    return {
      ...state,
      reports: {
        fetching: false,
        items: action.reports.map(codeItemToStoreValue)
      }
    };
  },
  [ACTION.REQUEST_FOLDER_FAVOURITE]: (state: SavedReportState, action: ReceiveReports): SavedReportState => {
    return {
      ...state,
      fetchingFolder: true
    };
  },
  [ACTION.RECEIVE_FOLDER_FAVOURITE]: (state: SavedReportState, action: ReceiveFolderFavourite) => {
    return {
      ...state,
      folderDefinition: action.definition,
      fetchingFolder: false
    };
  },  
  [ACTION.RECEIVE_SEARCH_REQUIRED_USERS]: (state: SavedReportState, action: ReceiveSearchRequiredUsers)
    : SavedReportState => {      
    return {
      ...state,
      searchRequiredUsers: action.searchRequiredUsers
    };
  },
  [ACTION.REQUEST_BOOKMARKED_REPORTS]: (state: SavedReportState, action: RequestBookmarkedReports): SavedReportState => {

    return {
      ...state,
      folderDefinition: null,
      bookmarkedReports: {
        fetching: true,
        items: []
      }
    };
  },

  [ACTION.RECEIVE_BOOKMARKED_REPORTS]: (state: SavedReportState, action: ReceiveBookmarkedReports): SavedReportState => {

    return {
      ...state,
      bookmarkedReports: {
        fetching: false,
        items: action.bookmarkedReports.map(codeItemToStoreValue)
      }
    };
  },

  [ACTION.CHANGE_VIEW_MODE]: (state: SavedReportState, action: ChangeViewMode): SavedReportState => {
    return {
      ...state,
      viewMode: action.mode
    };
  },

  [ACTION.CHANGE_VIEW_MODE_COMPANY_REPORT]: (state: SavedReportState, action: ChangeViewModeCompanyReport): SavedReportState => {
    return {
      ...state,
      viewModeCompanyReport: action.mode
    };
  },

  [ACTION.CHANGE_VIEW_MODE_DASHBOARD]: (state: SavedReportState, action: ChangeViewModeDashboard): SavedReportState => {
    return {
      ...state,
      viewModeDashboard: action.mode
    };
  }
};

export const reducer: Reducer<SavedReportState> = (state: SavedReportState = INITIAL_STATE, action: any) => {
  const r = reducers[action.type];
  return (r && r(state, action)) || simpleFormReducer(STATE.savedReport)(state, action);
};
